<template>
    <div class="header__container">
        <div class="logged__user">
            <div class="sideMenuHeader">Logged in as {{store.state.user.role}}</div>
            <div class="icon__holder">
                <img src="./../../assets/noun_profile.svg" alt="Account logo">
             </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@store/index.js'
export default {
  name: 'Header',
  data: function () {
      return {
          store: store
      }
  },
  computed: {        
    ...mapGetters({
        user: 'getUser',
    })
  }
}
</script>

<style scoped>
.header__container{
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
}

.icon__holder{
    background: #E6E6E6;
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.icon__holder img{
    width: 25px;
    height: 25px;
}

.logged__user{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding-right: 15px;
}

.sideMenuHeader{
    margin-top: 0;
    font-size: 12px;
    width: initial;
}
</style>